/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52107.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class ApiAccountControllerApi extends runtime.BaseAPI {
    /**
     */
    async createTemporaryAccessKeyRaw(requestParameters, initOverrides) {
        if (requestParameters.createTemporaryAccessKeyOptions === null || requestParameters.createTemporaryAccessKeyOptions === undefined) {
            throw new runtime.RequiredError('createTemporaryAccessKeyOptions', 'Required parameter requestParameters.createTemporaryAccessKeyOptions was null or undefined when calling createTemporaryAccessKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/temporary-access`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTemporaryAccessKeyOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createTemporaryAccessKey(requestParameters, initOverrides) {
        const response = await this.createTemporaryAccessKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteUser(initOverrides) {
        await this.deleteUserRaw(initOverrides);
    }
    /**
     */
    async expireForUserRaw(requestParameters, initOverrides) {
        if (requestParameters.updateChallengeOptions === null || requestParameters.updateChallengeOptions === undefined) {
            throw new runtime.RequiredError('updateChallengeOptions', 'Required parameter requestParameters.updateChallengeOptions was null or undefined when calling expireForUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateChallengeOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async expireForUser(requestParameters, initOverrides) {
        const response = await this.expireForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccountRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dto`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccount(initOverrides) {
        const response = await this.getAccountRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccount1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccount1(initOverrides) {
        const response = await this.getAccount1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getOtherAccountsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/others`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOtherAccounts(initOverrides) {
        const response = await this.getOtherAccountsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserAccountsRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling getUserAccounts.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserAccounts(requestParameters, initOverrides) {
        const response = await this.getUserAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserForPasswordRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling getUserForPassword.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getUserForPassword.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/login`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserForPassword(requestParameters, initOverrides) {
        const response = await this.getUserForPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async logoutRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async logout(initOverrides) {
        await this.logoutRaw(initOverrides);
    }
    /**
     */
    async refreshApiKeyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/apiKey`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async refreshApiKey(initOverrides) {
        const response = await this.refreshApiKeyRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async sendAccessLinkRaw(requestParameters, initOverrides) {
        if (requestParameters.accessOptions === null || requestParameters.accessOptions === undefined) {
            throw new runtime.RequiredError('accessOptions', 'Required parameter requestParameters.accessOptions was null or undefined when calling sendAccessLink.');
        }
        const queryParameters = {};
        if (requestParameters.isSignUp !== undefined) {
            queryParameters['isSignUp'] = requestParameters.isSignUp;
        }
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.requestedPlanId !== undefined) {
            queryParameters['requestedPlanId'] = requestParameters.requestedPlanId;
        }
        if (requestParameters.preventNonExistingUsers !== undefined) {
            queryParameters['preventNonExistingUsers'] = requestParameters.preventNonExistingUsers;
        }
        if (requestParameters.preventMultipleAccounts !== undefined) {
            queryParameters['preventMultipleAccounts'] = requestParameters.preventMultipleAccounts;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/access`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accessOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async sendAccessLink(requestParameters, initOverrides) {
        await this.sendAccessLinkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async sendForgotLinkRaw(requestParameters, initOverrides) {
        if (requestParameters.accessOptions === null || requestParameters.accessOptions === undefined) {
            throw new runtime.RequiredError('accessOptions', 'Required parameter requestParameters.accessOptions was null or undefined when calling sendForgotLink.');
        }
        const queryParameters = {};
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.requestedPlanId !== undefined) {
            queryParameters['requestedPlanId'] = requestParameters.requestedPlanId;
        }
        if (requestParameters.preventNonExistingUsers !== undefined) {
            queryParameters['preventNonExistingUsers'] = requestParameters.preventNonExistingUsers;
        }
        if (requestParameters.preventMultipleAccounts !== undefined) {
            queryParameters['preventMultipleAccounts'] = requestParameters.preventMultipleAccounts;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/forgot`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.accessOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async sendForgotLink(requestParameters, initOverrides) {
        await this.sendForgotLinkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async setPasswordRaw(requestParameters, initOverrides) {
        if (requestParameters.setPasswordOptions === null || requestParameters.setPasswordOptions === undefined) {
            throw new runtime.RequiredError('setPasswordOptions', 'Required parameter requestParameters.setPasswordOptions was null or undefined when calling setPassword.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setPasswordOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async setPassword(requestParameters, initOverrides) {
        await this.setPasswordRaw(requestParameters, initOverrides);
    }
    /**
     */
    async signUpRaw(requestParameters, initOverrides) {
        if (requestParameters.signUpOptions === null || requestParameters.signUpOptions === undefined) {
            throw new runtime.RequiredError('signUpOptions', 'Required parameter requestParameters.signUpOptions was null or undefined when calling signUp.');
        }
        const queryParameters = {};
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.sendVerification !== undefined) {
            queryParameters['sendVerification'] = requestParameters.sendVerification;
        }
        if (requestParameters.requestedPlanId !== undefined) {
            queryParameters['requestedPlanId'] = requestParameters.requestedPlanId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/sign-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.signUpOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async signUp(requestParameters, initOverrides) {
        const response = await this.signUpRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async validateTemporaryAccessKeyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling validateTemporaryAccessKey.');
        }
        if (requestParameters.endpoint === null || requestParameters.endpoint === undefined) {
            throw new runtime.RequiredError('endpoint', 'Required parameter requestParameters.endpoint was null or undefined when calling validateTemporaryAccessKey.');
        }
        const queryParameters = {};
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        if (requestParameters.endpoint !== undefined) {
            queryParameters['endpoint'] = requestParameters.endpoint;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/temporary-access/validate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async validateTemporaryAccessKey(requestParameters, initOverrides) {
        const response = await this.validateTemporaryAccessKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async verifyForOrganizationUserRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling verifyForOrganizationUser.');
        }
        if (requestParameters.organizationVerifyAccessOptions === null || requestParameters.organizationVerifyAccessOptions === undefined) {
            throw new runtime.RequiredError('organizationVerifyAccessOptions', 'Required parameter requestParameters.organizationVerifyAccessOptions was null or undefined when calling verifyForOrganizationUser.');
        }
        const queryParameters = {};
        if (requestParameters.slug !== undefined) {
            queryParameters['slug'] = requestParameters.slug;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/verify-organization`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationVerifyAccessOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async verifyForOrganizationUser(requestParameters, initOverrides) {
        const response = await this.verifyForOrganizationUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async verifyForSsoUserRaw(requestParameters, initOverrides) {
        if (requestParameters.sSOUserLink === null || requestParameters.sSOUserLink === undefined) {
            throw new runtime.RequiredError('sSOUserLink', 'Required parameter requestParameters.sSOUserLink was null or undefined when calling verifyForSsoUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/verify-sso`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sSOUserLink,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async verifyForSsoUser(requestParameters, initOverrides) {
        const response = await this.verifyForSsoUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async verifyForUserRaw(requestParameters, initOverrides) {
        if (requestParameters.challengeOptions === null || requestParameters.challengeOptions === undefined) {
            throw new runtime.RequiredError('challengeOptions', 'Required parameter requestParameters.challengeOptions was null or undefined when calling verifyForUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.challengeOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async verifyForUser(requestParameters, initOverrides) {
        const response = await this.verifyForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ValidateTemporaryAccessKeyEndpointEnum = {
    GET_EMAIL: 'GET_EMAIL',
    GET_ATTACHMENT: 'GET_ATTACHMENT',
    ALL: 'ALL'
};
